
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 48 48","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"currentColor","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M24 48c13.255 0 24-10.745 24-24S37.255 0 24 0 0 10.745 0 24s10.745 24 24 24zm0-3C12.402 45 3 35.598 3 24S12.402 3 24 3s21 9.402 21 21-9.402 21-21 21z","fill-rule":"nonzero"}}),_c('circle',{attrs:{"cx":"16.5","cy":"17.5","r":"2.5"}}),_c('circle',{attrs:{"cx":"31.5","cy":"17.5","r":"2.5"}}),_c('path',{attrs:{"d":"M9.587 26.502C11.92 33.07 17.57 37.5 24 37.5c6.43 0 12.08-4.43 14.413-10.998A1.5 1.5 0 0037 24.5H11a1.5 1.5 0 00-1.413 2.002zm25.127.998c-2.24 4.285-6.276 7-10.714 7-4.335 0-8.286-2.59-10.555-6.704l-.16-.296h21.43z","fill-rule":"nonzero"}})])])
          )
        }
      }
    